import React from 'react'
import './Search.css'

const SearchUI = ({value, onChange}) =>
  <input
    className={`w_search ${value ? '' : 'empty'}`}
    placeholder="&#98;"
    value={value}
    onChange={onChange}
  />

export default SearchUI
